/**
 * Scroll reveal — pairs with the .reveal utility in snippet-theme-tokens.liquid.
 * Honors prefers-reduced-motion (does nothing; CSS gate means content is fully
 * visible without this script — progressive enhancement, no JS required to read).
 * Stagger: set --reveal-delay inline per item (see section-editorial-grid.liquid).
 * Load with: <script src="{{ 'scroll-reveal.js' | asset_url }}" defer></script>
 */
(() => {
  if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
  document.documentElement.classList.add('js-reveal');
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  const init = (root = document) => {
    root.querySelectorAll('.reveal:not(.is-visible)').forEach((el) => io.observe(el));
  };

  init();

  // Re-bind inside the theme editor when sections re-render.
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
